"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivedPage = void 0;
var query_string_1 = __importDefault(require("query-string"));
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var Page_1 = require("@app/components/layout/Page");
var constants_1 = require("@app/shared/constants");
var utils_1 = require("@app/shared/utils");
var initialState = {
    isLoading: true,
    packageId: undefined
};
/**
 * This page used to be an intermediary for the Faspex received package email urls.
 * Where a deliveryId would be used to retrieve the actual package information and then redirect to the package details page.
 *
 * The upgrade to Faspex5 changed the make-up of the Faspex received package email urls, including the intended recipient's email.
 * This page is now used as a validation that the logged-in user is the intended recipient, resulting in landing either on the package details or an error page.
 */
var ReceivedPage = /** @class */ (function (_super) {
    __extends(ReceivedPage, _super);
    function ReceivedPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        return _this;
    }
    ReceivedPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var deliveryId;
            return __generator(this, function (_a) {
                deliveryId = this.props.match.params.deliveryId || '';
                try {
                    this.setState({ packageId: deliveryId });
                }
                finally {
                    this.setState({ isLoading: false });
                }
                return [2 /*return*/];
            });
        });
    };
    ReceivedPage.prototype.render = function () {
        var _a = this.state, isLoading = _a.isLoading, packageId = _a.packageId;
        var recipientEmail = query_string_1.default.parse(this.props.location.search).recipient;
        if (!isLoading && packageId) {
            var jwt = sessionStorage.getItem(constants_1.JWT_STORAGE_KEY);
            if (jwt) {
                // The user is already logged-in, compare their email with the recipient
                var decodedJwt = utils_1.decodeJwt(jwt);
                if (decodedJwt.auth.user.userEmail === recipientEmail) {
                    return react_1.default.createElement(react_router_1.Redirect, { to: "/dash/packages/" + (this.state.packageId || '') });
                }
                else {
                    window.location.assign("/error/" + constants_1.EMAIL_MISMATCH);
                }
            }
            // For some reason there's no user logged in, send to dash which will force a login
            return react_1.default.createElement(react_router_1.Redirect, { to: "/dash" });
        }
        // Missing package id, redirect to the home page
        if (!isLoading && !packageId) {
            return react_1.default.createElement(react_router_1.Redirect, { to: "/dash" });
        }
        return (react_1.default.createElement(Page_1.Page, { title: "Received Package", isLoading: isLoading }));
    };
    return ReceivedPage;
}(react_1.Component));
exports.ReceivedPage = ReceivedPage;
